import './hero.scss';
import "swiper/css";
import "swiper/css/pagination";

import {
    Swiper,
    SwiperSlide
} from "swiper/react";
import {
    Autoplay,
    Pagination
} from "swiper";

import SwiperCard from '../../../components/swiperCard/swiperCard';

import { hero } from '../../../constants/hero';

export default function Hero() {
    return (
        <Swiper
            spaceBetween={ 30 }
            slidesPerView={ 1 }
            centeredSlides={ true }
            autoplay={{
                delay: 5000,
                disableOnInteraction: false
            }}
            pagination={{
                clickable: true
            }}
            
            loop={ true }
            modules={[ Autoplay, Pagination ]}
            tag='section'
            id='Hero'
        >
            {hero.map((val, i) => (
                <SwiperSlide key={ i }>
                    <SwiperCard
                        image={ `${process.env.PUBLIC_URL}/images/hero/${val.image}.jpg` }
                        title={ val.title }
                        description={ val.description }
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};